<script lang="ts">
	import { storyblokEditable } from '@storyblok/svelte';
	import Icon from '$lib/elements/Icon.svelte';
	import { richTextToHTML } from '@app/utils/cms';
	import type { InlineIconTextProps } from '@app/components/cms/types';
	import { getLightBgColorClassName, getTextColorClassName } from '$lib/theme/colors';

	export let props: InlineIconTextProps;
</script>

<div use:storyblokEditable={props} class="flex items-start space-x-3">
	<div
		class="{props.isIconInsideSquare
			? `${getLightBgColorClassName(props.iconColor)} p-2 rounded-lg`
			: ''} flex-shrink-0 {getTextColorClassName(props.iconColor)}"
	>
		<Icon name={props.icon} />
	</div>
	<div>
		{#if props.title}
			<div class="text-lg font-semibold">{props.title}</div>
		{/if}
		{@html richTextToHTML(props.text)}
	</div>
</div>
